var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_2811)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3853 9.5992C28.7759 9.20867 28.7759 8.57551 28.3853 8.18498C27.9948 7.79446 27.3616 7.79446 26.9711 8.18498L14.9711 20.185C14.5806 20.5755 14.5806 21.2087 14.9711 21.5992C15.3616 21.9897 15.9948 21.9897 16.3853 21.5992L28.3853 9.5992ZM15.4931 11.9817C16.7486 11.7925 18.0312 11.9047 19.2349 12.3089C19.7584 12.4847 20.3254 12.2029 20.5012 11.6793C20.677 11.1557 20.3951 10.5888 19.8716 10.413C18.3672 9.9078 16.7644 9.76761 15.1952 10.004C13.626 10.2403 12.1355 10.8464 10.8467 11.7723C9.55797 12.6982 8.50786 13.9173 7.78306 15.329C7.05826 16.7407 6.67957 18.3045 6.67822 19.8914V19.8922C6.67824 20.2629 6.69861 20.6334 6.73925 21.0018C6.7998 21.5508 7.2939 21.9467 7.84285 21.8862C8.39181 21.8256 8.78774 21.3315 8.7272 20.7826C8.6946 20.487 8.67825 20.1899 8.67822 19.8926C8.67937 18.623 8.98238 17.3719 9.56226 16.2425C10.1422 15.1129 10.9825 14.1375 12.0137 13.3966C13.0449 12.6558 14.2375 12.1708 15.4931 11.9817Z",
    fill: "url(#paint0_linear_191_2811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2557 13.9721C29.0575 15.5454 29.5317 17.265 29.6494 19.0269C29.7672 20.7887 29.5261 22.5562 28.9407 24.2221C28.8723 24.4185 28.7445 24.5887 28.5749 24.709C28.4053 24.8293 28.2024 24.8938 27.9945 24.8934H5.36071C5.15238 24.8925 4.94947 24.8269 4.77998 24.7058C4.61049 24.5847 4.48277 24.4139 4.41446 24.2171C3.91449 22.7955 3.66537 21.2978 3.67821 19.7909C3.73321 12.6421 9.64446 6.82837 16.8032 6.89212C18.8209 6.90831 20.807 7.39541 22.6032 8.31462",
    stroke: "url(#paint1_linear_191_2811)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_2811",
    x1: 6.67822,
    y1: 19.2752,
    x2: 29.6478,
    y2: 11.2487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FED961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FEE180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFCA47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_191_2811",
    x1: 7.0366,
    y1: 8.70369,
    x2: 28.3753,
    y2: 24.8934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FED961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FEE180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFCA47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_2811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.678223 0.89209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer);
export default __webpack_public_path__ + "static/media/Speedometer.303e47168766089d1b006724a606b4fa.svg";
export { ForwardRef as ReactComponent };